// import React from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "../components/layout/Layout";
import LoginNew from "../features/login/Login";
import User from "../features/user/User";
import CreateUser from "../features/user/CreateUser";
import UserType from "../features/userType/UserType";
import CreateUserType from "../features/userType/CreateUserType";
import Rights from "../features/rights/Rights";
import Menu from "../features/menu/Menu";
import PrivateRoute from "./PrivateRoute";
import Dashboard from "../features/dashboard/Dashboard";
// import LoginNew from "../features/login/LoginNew";
import PendingDocumentTourBooking from "../features/dashboard/lists/PendingDocumentTourBooking";
import TotalTourBooking from "../features/dashboard/lists/TotalTourBooking";
// import TotalPayment from "../features/dashboard/lists/TotalPayment";
import TotalPendingPayment from "../features/dashboard/lists/TotalPendingPayment";
import TotalDepartureInNextFifteenDay from "../features/dashboard/lists/TotalDepartureInNextFifteenDay";

import Banner from "../features/banner/Banner";
import CreateBanner from "../features/banner/CreateBanner";
import CMS from "../features/cms/CMS";
import SeoTag from "../features/seotag/SeoTag";
import CreateSeoTag from "../features/seotag/CreateSeoTag";
import Testimonial from "../features/testimonial/Testimonial";
import CreateCMS from "../features/cms/CreateCMS";
import Service from "../features/service/Service";
import CreateService from "../features/service/CreateService";
import FAQ from "../features/faq/FAQ";
import CreateFAQ from "../features/faq/CreateFAQ";
// import UsefulLinks from "../features/usefullinks/UsefulLinks";
// import CreateUsefulLinks from "../features/usefullinks/CreateUsefulLinks";
import Contact from "../features/contact/Contact";
import Setting from "../features/setting/Setting";
import TicketBooking from "../features/ticketbooking/TicketBooking";
import Workflow from "../features/workflow/Workflow";
import CreateWorkflow from "../features/workflow/CreateWorkflow";
import Industry from "../features/industry/Industry";
import CreateIndustry from "../features/industry/CreateIndustry";
import Uniform from "../features/uniform/Uniform";
import ClientLogo from "../features/clientlogo/ClientLogo";
import About from "../features/about/About";
import Tour from "../features/tour/Tour";
import CreateTour from "../features/tour/CreateTour";
import Company from "../features/company/Company";
import CreateCompany from "../features/company/CreateCompany";
import Hotel from "../features/hotel/Hotel";
import CreateHotel from "../features/hotel/CreateHotel";
import Currency from "../features/currency/Currency";
import Country from "../features/country/Country";
import State from "../features/state/State";
import City from "../features/city/City";
import RoomType from "../features/roomtype/RoomType";
import Sector from "../features/sector/Sector";
import CreateSector from "../features/sector/CreateSector";
import Itinerary from "../features/itinerary/Itinerary";
import CreateItineary from "../features/itinerary/CreateItinerary";
import ItineraryFacility from "../features/ItineraryFacility/ItineraryFacility";
import SpecialityType from "../features/specialitytype/SpecialityType";
import VehicleSharingPax from "../features/vehiclesharingpax/VehicleSharingPax";
import Gst from "../features/gst/Gst";
import Region from "../features/region/Region";
// import AdminSetting from "../features/adminsetting/AdminSetting";
import OurExpertise from "../features/ourexpertise/OurExpertise";
import Blog from "../features/blog/Blog";
import CreateBlog from "../features/blog/CreateBlog";
import WebBranch from "../features/webbranch/WebBranch";
import CreateWebBranch from "../features/webbranch/CreateWebBranch";

const MainRouter = () => {
  return (
    <Routes>
      {/* <Route path="login" element={<LogIn />} /> */}
      {/* <Route path="newlogin" element={<NewLogin />} /> */}
      <Route path="login" element={<LoginNew />} />

      <Route
        path="/"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route index={true} element={<Dashboard />} />
        <Route element={<Banner />} />
        <Route path="menu" element={<Menu />} />
        <Route path="rights" element={<Rights />} />
        <Route path="user" element={<User />} />
        <Route path="user/create" element={<CreateUser />} />
        <Route path="user/edit" element={<CreateUser />} />
        <Route path="usertype" element={<UserType />} />
        <Route path="usertype/create" element={<CreateUserType />} />
        <Route path="usertype/edit" element={<CreateUserType />} />
        <Route path="cms" element={<CMS />} />
        <Route path="cms/edit" element={<CreateCMS />} />
        <Route path="cms/create" element={<CreateCMS />} />
        <Route path="banner" element={<Banner />} />
        <Route path="banner/create" element={<CreateBanner />} />
        <Route path="banner/edit" element={<CreateBanner />} />
        <Route path="seotag" element={<SeoTag />} />
        <Route path="seotag/create" element={<CreateSeoTag />} />
        <Route path="seotag/edit" element={<CreateSeoTag />} />
        <Route path="testimonial" element={<Testimonial />} />
        <Route path="uniform" element={<Uniform />} />
        <Route path="client" element={<ClientLogo />} />
        <Route path="service" element={<Service />} />
        <Route path="service/create" element={<CreateService />} />
        <Route path="service/edit" element={<CreateService />} />

        <Route path="faq" element={<FAQ />} />
        <Route path="faq/create" element={<CreateFAQ />} />
        <Route path="faq/edit" element={<CreateFAQ />} />

        {/* <Route path="usefullinks" element={<UsefulLinks />} />
        <Route path="usefullinks/create" element={<CreateUsefulLinks />} />
        <Route path="usefullinks/edit" element={<CreateUsefulLinks />} /> */}
        <Route path="inquiries" element={<Contact />} />
        <Route path="setting" element={<Setting />} />
        <Route
          path="dashboard/pendingdocumenttourbooking"
          element={<PendingDocumentTourBooking />}
        />
        <Route path="dashboard/ticketbookings" element={<TotalTourBooking />} />
        <Route path="dashboard/totalpayments" element={<TotalTourBooking />} />
        {/* <Route path="dashboard/payments" element={<TotalPayment />} /> */}
        <Route
          path="dashboard/pendingpayments"
          element={<TotalPendingPayment />}
        />
        <Route
          path="dashboard/next15daysdeparture"
          element={<TotalDepartureInNextFifteenDay />}
        />
        <Route path="ticketbooking" element={<TicketBooking />} />
        <Route path="workflow" element={<Workflow />} />
        <Route path="workflow/create" element={<CreateWorkflow />} />
        <Route path="workflow/edit" element={<CreateWorkflow />} />
        <Route path="industry" element={<Industry />} />
        <Route path="industry/create" element={<CreateIndustry />} />
        <Route path="industry/edit" element={<CreateIndustry />} />
        <Route path="about" element={<About />} />
        <Route path="tour" element={<Tour />} />
        <Route path="tour/create" element={<CreateTour />} />
        <Route path="tour/edit" element={<CreateTour />} />
        <Route path="company" element={<Company />} />
        <Route path="company/create" element={<CreateCompany />} />
        <Route path="company/edit" element={<CreateCompany />} />
        <Route path="hotel" element={<Hotel />} />
        <Route path="hotel/create" element={<CreateHotel />} />
        <Route path="hotel/edit" element={<CreateHotel />} />
        <Route path="currency" element={<Currency />} />
        <Route path="country" element={<Country />} />
        <Route path="state" element={<State />} />
        <Route path="city" element={<City />} />
        <Route path="roomtype" element={<RoomType />} />
        <Route path="sector" element={<Sector />} />
        <Route path="sector/create" element={<CreateSector />} />
        <Route path="sector/edit" element={<CreateSector />} />
        <Route path="itinerary" element={<Itinerary />} />
        <Route path="itineary/edit" element={<CreateItineary />} />
        <Route path="itineary/create" element={<CreateItineary />} />
        <Route path="itineraryfacility" element={<ItineraryFacility />} />
        <Route path="specialitytype" element={<SpecialityType />} />
        <Route path="gst" element={<Gst />} />
        <Route path="vehiclesharingpax" element={<VehicleSharingPax />} />
        <Route path="region" element={<Region />} />
        <Route path="blog" element={<Blog />} />
        <Route path="blog/create" element={<CreateBlog />} />
        <Route path="blog/edit" element={<CreateBlog />} />
        <Route path="webbranch" element={<WebBranch />} />
        <Route path="webbranch/create" element={<CreateWebBranch />} />
        <Route path="webbranch/edit" element={<CreateWebBranch />} />
        {/* <Route path="festivals" element={<Festivals />} /> */}
        {/* <Route path="adminsetting" element={<AdminSetting />} /> */}
        <Route path="ourexpertise" element={<OurExpertise />} />

        <Route path="*" element={<h1>404</h1>} />
      </Route>
    </Routes>
  );
};

export default MainRouter;
